import { AxiosRequestHeaders } from 'axios'

import axios from './config'

export async function get<T>(
  url: string,
  params: Record<string, unknown> = {},
  headers?: AxiosRequestHeaders,
  signal?: AbortSignal
) {
  return (await axios.get<T>(url, { params, headers, signal })).data
}

/** Like get, but returns undefined for 4xx instead of throwing (avoids dev overlay noise). */
export async function getOptional<T>(
  url: string,
  params: Record<string, unknown> = {},
  headers?: AxiosRequestHeaders,
  signal?: AbortSignal,
) {
  const response = await axios.get<T>(url, {
    params,
    headers,
    signal,
    validateStatus: (status) => status < 500,
  })

  if (response.status >= 400) {
    return undefined
  }

  return response.data
}

export async function post<T>(
  url: string,
  body: Record<string, unknown> | FormData,
  headers?: AxiosRequestHeaders
) {
  return (await axios.post<T>(url, body, { headers })).data
}

export async function put<T>(
  url: string,
  body: Record<string, unknown> | Blob | null,
  headers?: AxiosRequestHeaders
) {
  return (await axios.put<T>(url, body, { headers })).data
}

export async function patch<T>(
  url: string,
  body: Record<string, unknown>,
  headers?: AxiosRequestHeaders
) {
  return (await axios.patch<T>(url, body, { headers })).data
}

export async function remove<T>(
  url: string,
  params: Record<string, unknown> = {},
  headers?: AxiosRequestHeaders
) {
  return (await axios.delete<T>(url, { params, headers })).data
}
